import React from 'react';
import '../style.scss';

const Twitter = (props) => {

    return (
        <svg id="Layer_1" className="btn-social" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"  xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 93.25 75.78">
            <defs></defs>
            <path   d="M344.12,391.58a38.25,38.25,0,0,1-11,3A19.18,19.18,0,0,0,341.55,384a38.42,38.42,0,0,1-12.15,4.64,19.16,19.16,0,0,0-32.6,17.45,54.31,54.31,0,0,1-39.43-20,19.15,19.15,0,0,0,5.92,25.54,19.06,19.06,0,0,1-8.66-2.39v.24A19.14,19.14,0,0,0,270,428.26a19,19,0,0,1-5,.67,19.44,19.44,0,0,1-3.6-.34,19.16,19.16,0,0,0,17.87,13.29,38.6,38.6,0,0,1-28.33,7.92,54.12,54.12,0,0,0,29.31,8.59c35.2,0,54.42-29.15,54.42-54.43,0-.83,0-1.65-.05-2.47A38.66,38.66,0,0,0,344.12,391.58Z" transform="translate(-250.88 -382.61)"/>
        </svg>

    )
}
export default Twitter;